import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import documentTemplateFileFetched, {
	type DocumentTemplateFileFetchedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentTemplateFileFetched';
import documentTemplateFileFetchFailed, {
	type DocumentTemplateFileFetchFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentTemplateFileFetchFailed';
import type FetchDocumentTemplateFile from '@Application/Beneficiaries/Documents/Queries/FetchDocumentTemplateFile';
import ensureDocxKitModules from '@Application/Documents/DocxKit/ensureDocxKitModules';
import { getFile } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentTemplateFileFetchedAction | DocumentTemplateFileFetchFailedAction;

export default (query: FetchDocumentTemplateFile) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await ensureDocxKitModules();

			const { blob } = await getFile(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/documents/${query.documentId}/template-file`,
			);
			const bytes = new Uint8Array(await blob.arrayBuffer());

			const action = documentTemplateFileFetched({ templateVersionId: query.templateVersionId, bytes });
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTemplateFileFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
